import $ from "jquery";
import React, {useEffect, useRef, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import HashLoader from "react-spinners/HashLoader";
import {toast} from 'react-toastify';
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../components/Api/PostLoginPostApi';
import Button from '../../../components/Button';
import init from '../AccessControl/Check';
import {ReactComponent as CloseBtn} from './../../../assets/icons/close.svg';
import {
    MAX_UPLOAD_FILE_SIZE,
    COMPANY_BANNER_IMAGE_H,
    COMPANY_BANNER_IMAGE_W,
    COMPANY_BANNER_IMAGE_D_RATION
} from "../../../components/Constants/FileUpload";

const CreateCompany = () => {
    const pageName = "Company Add";
    const isAccess = init(pageName);
    const navigate = useNavigate();
    const [categoryList, setCategoryList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [mobileNumber, setMobileNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState({
        user_id: "",
        name: "",
        name2: "",
        business_category_id: "",
        logo: "",
        banner: "",
        mobile_no: "",
        email: "",
        address: "",
        current_address: "",
        settlement_type: "",
        commission: "",
        commission_type: 1,
        settlement_cycle: "",
        voucher: "",
        shop: "",
        position: "",


        bank_account_name: "",
        bank_account_number: "",
        bank_id: "",
        bank_branch_id: "",
        bank_routing: "",
        partner_name: "",
        partner_address: "",
        partner_phone: "",
        partner_email: "",
        poc_name: "",
        poc_designation: "",
        poc_phone: "",
        poc_email: "",
        trade_license: "",
        tin: "",
        incorporation: "",
        owner_nid: "",
        poc_visiting_card: "",
        registration_form: "",
        other: "",
        description: ""

    })
    const handleInputChange = (e) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;


        if (e.target.name === "name2") {
            setInput({...input, name2: value, bank_account_name: value});
            return;
        }

        if (e.target.name === "user_id") {
            var poc_name = $("#user_id").find(':selected').data("name");
            var poc_email = $("#user_id").find(':selected').data("email");
            var poc_cell_phone = $("#user_id").find(':selected').data("phone");

            input["poc_name"] = poc_name;
            input["poc_email"] = poc_email;
            input["poc_phone"] = poc_cell_phone;
        }

        if (e.target.name === "settlement_cycle" || e.target.name === "position") {
            const re = /^[0-9]*?$/;
            if (!re.test(value)) {
                return;
            }
        }

        setInput({...input, [e.target.name]: value});
    }
    const submitFormData = (event) => {
        event.preventDefault();

        if (file === undefined) {
            toast.error("Please upload your company logo !");
            return;
        }

        if (file5 === undefined) {
            toast.error("Please upload your banner !");
            return;
        }

        let requestBody = new FormData();

        requestBody.append("user_id", input.user_id);
        requestBody.append("name", input.name);
        requestBody.append("name2", input.name2);
        requestBody.append("business_category_id", input.business_category_id);
        requestBody.append("logo", file);
        if (file5) {
            requestBody.append("banner", file5);
        }
        requestBody.append("mobile_no", mobileNumber);
        requestBody.append("email", input.email);
        requestBody.append("address", input.address);
        requestBody.append("current_address", input.current_address);
        requestBody.append("description", input.description);
        requestBody.append("settlement_type", input.settlement_type);
        requestBody.append("commission", input.commission);
        requestBody.append("commission_type", input.commission_type);
        requestBody.append("settlement_cycle", input.settlement_cycle);
        requestBody.append("voucher", input.voucher);
        requestBody.append("shop", input.shop);
        requestBody.append("position", input.position);

        requestBody.append("bank_account_name", input.bank_account_name);
        requestBody.append("bank_account_number", input.bank_account_number);
        requestBody.append("bank_id", input.bank_id);
        requestBody.append("bank_branch_id", input.bank_branch_id);
        requestBody.append("bank_routing", input.bank_routing);
        requestBody.append("partner_name", input.partner_name);
        requestBody.append("partner_address", input.partner_address);
        requestBody.append("partner_phone", input.partner_phone);
        requestBody.append("partner_email", input.partner_email);
        requestBody.append("poc_name", input.poc_name);
        requestBody.append("poc_designation", input.poc_designation);
        requestBody.append("poc_phone", input.poc_phone);
        requestBody.append("poc_email", input.poc_email);

        if (file2) {
            requestBody.append("trade_license", file2);
        }

        if (file3) {
            requestBody.append("tin", file3);
        }

        if (file4) {
            requestBody.append("incorporation", file4);
        }

        if (file6) {
            requestBody.append("owner_nid", file6);
        }
        if (file7) {
            requestBody.append("poc_visiting_card", file7);
        }
        if (file8) {
            requestBody.append("registration_form", file8);
        }
        if (file9) {
            requestBody.append("other", file9);
        }


        // Create company
        setLoading(true);
        PostLoginPostApi("create-company", requestBody, 3, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success("Company created successfully.");
                    return navigate("/dashboard/company");
                }

                toast.error(responseData["message"].toString());
            }
        }).catch((error) => {
            toast.error("A problem occur. Please try again.");
            console.log(error);
        }).finally(() => {
            setLoading(false);
            return;
        });
    }
    const [bankList, setBankList] = useState([]);
    const [branchList, setBranchList] = useState([]);

    useEffect(() => {

        // Business Category List
        PostLoginGetApi("business/category-all", "", 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setCategoryList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        })


        // Bank List
        PostLoginGetApi("banks", "", 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setBankList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });

    }, []);

    useEffect(() => {
        setBranchList([]);

        PostLoginPostApi("branches", JSON.stringify({bank_id: input.bank_id}), 4).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setBranchList(responseData["data"]);
                    $("#bank_branch_id").focus();
                }
            }
        }).catch((err) => {
            console.log(err);
        });

    }, [input.bank_id]);

    // Users list
    useEffect(() => {
        PostLoginGetApi("user/list", {all: 1}, 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setUserList(responseData["data"]["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        })
    }, []);


    const fileInput = useRef();
    const fileInput2 = useRef();
    const fileInput3 = useRef();
    const fileInput4 = useRef();
    const fileInput5 = useRef();
    const fileInput6 = useRef();
    const fileInput7 = useRef();
    const fileInput8 = useRef();
    const fileInput9 = useRef();
    const [file, setFile] = useState();
    const [file2, setFile2] = useState();
    const [file3, setFile3] = useState();
    const [file4, setFile4] = useState();
    const [file5, setFile5] = useState();
    const [file6, setFile6] = useState();
    const [file7, setFile7] = useState();
    const [file8, setFile8] = useState();
    const [file9, setFile9] = useState();

    const selectFile = () => {
        fileInput.current.click();
    }

    const selectFile2 = () => {
        fileInput2.current.click();
    }

    const selectFile3 = () => {
        fileInput3.current.click();
    }

    const selectFile4 = () => {
        fileInput4.current.click();
    }

    const selectFile5 = () => {
        fileInput5.current.click();
    }

    const selectFile6 = () => {
        fileInput6.current.click();
    }

    const selectFile7 = () => {
        fileInput7.current.click();
    }

    const selectFile8 = () => {
        fileInput8.current.click();
    }

    const selectFile9 = () => {
        fileInput9.current.click();
    }

    const handleChange = (e) => {
        if (!e.target?.files[0]) {
            return;
        }

        if (!e.target.files[0]?.type.includes("image/")) {
            toast.error("Please upload valid Image file");
            return;
        }

        if (e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        setFile(e.target.files[0]);
    }

    const handleChange2 = (e) => {
        if (!e.target?.files[0]) {
            return;
        }

        if (!e.target.files[0]["type"].includes("image/") && e.target.files[0]["type"] !== "application/pdf") {
            toast.error("Please upload valid PDF or Image file.");
            return;
        }

        if (e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        setFile2(e.target.files[0]);
    }

    const handleChange3 = (e) => {
        if (!e.target?.files[0]) {
            return;
        }

        if (!e.target.files[0]["type"].includes("image/") && e.target.files[0]["type"] !== "application/pdf") {
            toast.error("Please upload valid PDF or Image file.");
            return;
        }

        if (e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        setFile3(e.target.files[0]);
    }

    const handleChange4 = (e) => {
        if (!e.target?.files[0]) {
            return;
        }

        if (!e.target.files[0]["type"].includes("image/") && e.target.files[0]["type"] !== "application/pdf") {
            toast.error("Please upload valid PDF or Image file.");
            return;
        }

        if (e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        setFile4(e.target.files[0]);
    }

    const handleChange5 = (e) => {
        if (!e.target?.files[0]) {
            return;
        }

        if (!e.target.files[0]["type"].includes("image/")) {
            toast.error("Please upload valid image file.");
            return;
        }

        if (e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }


        let img = new Image();
        img.src = window.URL.createObjectURL(e.target.files[0]);
        img.onload = async () => {
            let w = img.width, h = img.height;

            if (w < COMPANY_BANNER_IMAGE_W || h < COMPANY_BANNER_IMAGE_H) {
                toast.error("Please upload company banner with proper dimension : " + COMPANY_BANNER_IMAGE_W + " x " + COMPANY_BANNER_IMAGE_H);
            } else {
                let r = parseFloat(w / h).toFixed(2);
                if (r !== COMPANY_BANNER_IMAGE_D_RATION) {
                    toast.error("Please upload company banner with valid ratio (w/h) : " + parseInt(COMPANY_BANNER_IMAGE_D_RATION));
                } else {
                    setFile5(e.target.files[0]);
                }
            }
        };
    }

    const handleChange6 = (e) => {
        if (!e.target?.files[0]) {
            return;
        }

        if (!e.target.files[0]["type"].includes("image/") && e.target.files[0]["type"] !== "application/pdf") {
            toast.error("Please upload valid PDF or Image file.");
            return;
        }

        if (e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        setFile6(e.target.files[0]);
    }

    const handleChange7 = (e) => {
        if (!e.target?.files[0]) {
            return;
        }

        if (!e.target.files[0]["type"].includes("image/") && e.target.files[0]["type"] !== "application/pdf") {
            toast.error("Please upload valid PDF or Image file.");
            return;
        }

        if (e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        setFile7(e.target.files[0]);
    }

    const handleChange8 = (e) => {
        if (!e.target?.files[0]) {
            return;
        }

        if (!e.target.files[0]["type"].includes("image/") && e.target.files[0]["type"] !== "application/pdf") {
            toast.error("Please upload valid PDF or Image file.");
            return;
        }

        if (e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        setFile8(e.target.files[0]);
    }

    const handleChange9 = (e) => {
        if (!e.target?.files[0]) {
            return;
        }

        if (!e.target.files[0]["type"].includes("image/") && e.target.files[0]["type"] !== "application/pdf") {
            toast.error("Please upload valid PDF or Image file.");
            return;
        }

        if (e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        setFile9(e.target.files[0]);
    }

    const mobileNumberHandler = (event) => {
        const result = event.target.value.replace(/\D/g, '');
        setMobileNumber(result);

    }

    const commissionAmountHandle = (e) => {
        const re = /^[0-9]*(\.[0-9]{0,2})?$/;
        const dt = $("input[type='radio'][name='commission_type']:checked").val();

        if (dt === "percentage" && e.value > 100) {
            return;
        }

        if (re.test(e.value)) {
            setInput({...input, commission: e.value});
        }
    }

    const setCommissionAmount = () => {
        let commission_type = 2;
        const dt = $("input[type='radio'][name='commission_type']:checked").val();
        if (dt === "percentage") {
            commission_type = 1;
        }

        setInput({...input, commission_type: commission_type, commission: ""});
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                <tr>
                    <td className="font-semibold text-base">
                        You do not have any access !
                    </td>
                </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <div className='flex justify-center items-center w-full h-screen'>

            {loading ?
                <HashLoader
                    color={"#1882FF"}
                    loading={loading}
                    size={150}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                /> :

                <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
                    <div className="font-medium pb-[60px]">
                        <header
                            className="flex justify-between items-center p-4 border-b-2 border-dark-white mb-[60px]">
                            <Link to="/dashboard/company"><CloseBtn/></Link>
                            <p className="text-xl text-black text-center">Create Company</p>
                            <div></div>
                        </header>
                        <main className="max-w-3xl m-auto mb-[60px]">
                            <div className="flex justify-center">
                                <form action='' autoComplete="off" method='POST' className="w-full"
                                      onSubmit={(event) => submitFormData(event)}>

                                    <div className="relative pb-2 pt-1 mb-1">
                                        <select name="business_category_id" id="business_category_id"
                                                onChange={handleInputChange} value={input.business_category_id}
                                                className='w-full rounded border-solid border border-dark-white'
                                                required>
                                            <option className='hidden' value="">Business Category *</option>
                                            {categoryList.map((data, index) => (
                                                <option key={index} value={data.id}
                                                        className='text-black'>{data.name}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="name" id="name" value={input.name}
                                               onChange={handleInputChange} title="Doing Business As" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                               required/>

                                        <label htmlFor="name"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Doing
                                            Business As *</label>
                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="name2" id="name2" value={input.name2}
                                               onChange={handleInputChange} title="Company Name" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                               required/>

                                        <label htmlFor="name2"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Company
                                            Name *</label>
                                    </div>


                                    <div className="relative pb-2 pt-1 mb-1">
                                        <input type="tel" name="mobile_no" id="mobile_no" value={mobileNumber}
                                               onChange={mobileNumberHandler} title="Mobile No." placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                               maxLength={13} required/>

                                        <label htmlFor="mobile_no"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Mobile
                                            Number *</label>
                                    </div>

                                    <div className="relative pb-2 pt-1 mb-1">
                                        <input type="email" name="email" id="email" value={input.email}
                                               onChange={handleInputChange} title="Email" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                               required/>

                                        <label htmlFor="email"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Email
                                            *</label>
                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="address" id="address" value={input.address}
                                               onChange={handleInputChange} title="Current Address" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                               required/>

                                        <label htmlFor="address"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Address
                                            (as per Trade License) *</label>
                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="current_address" id="current_address"
                                               value={input.current_address} onChange={handleInputChange}
                                               title="Current Address" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                               required/>

                                        <label htmlFor="current_address"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Current
                                            Address *</label>
                                    </div>
                                    <div className="relative py-2 mb-1">
                                        <textarea name="description" id="description"
                                               value={input.description} onChange={handleInputChange}
                                               title="Description" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                               />

                                        <label htmlFor="description"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Description</label>
                                    </div>


                                    <div className="flex pb-2 pt-1 mb-1 items-center">

                                        <div
                                            className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md"
                                            style={{border: "1px solid #e0e0e0"}}>
                                            <input type="file" name="logo" className="hidden" ref={fileInput}
                                                   onChange={handleChange}/>
                                            <label htmlFor="logo" className="p-1 text-base font-medium">Company Logo
                                                *</label>

                                            {file ?
                                                <>
                                                    <img src={URL.createObjectURL(file)} alt="Preview Logo"
                                                         className="max-h-10 max-w-10 ml-auto order-3"/>
                                                    <button type="button"
                                                            className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs"
                                                            onClick={selectFile}>Change
                                                    </button>
                                                </> :
                                                <>
                                                    <button type="button"
                                                            className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base"
                                                            onClick={selectFile}>Upload
                                                    </button>
                                                </>
                                            }

                                        </div>

                                        <div
                                            className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md ml-auto order-2"
                                            style={{border: "1px solid #e0e0e0"}}>
                                            <input type="file" name="banner" className="hidden" ref={fileInput5}
                                                   onChange={handleChange5}/>
                                            <label htmlFor="banner" className="p-1 text-base font-medium">
                                                Company Banner *
                                            </label>

                                            {file5 ?
                                                <>
                                                    <img src={URL.createObjectURL(file5)} alt="Preview Banner"
                                                         className="max-h-10 max-w-10 ml-auto order-3"/>
                                                    <button type="button"
                                                            className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs"
                                                            onClick={selectFile5}>Change
                                                    </button>
                                                </> :
                                                <>
                                                    <button type="button"
                                                            className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base"
                                                            onClick={selectFile5}>Upload
                                                    </button>
                                                </>}
                                        </div>
                                    </div>


                                    {/* Settlement Type */}
                                    <div className="flex border border-dashed border-green-500 px-2 mt-4 mb-2 rounded-md">
                                        <p className="text-[18px] pr-3 pt-[6px] ">
                                            Settlement Type
                                        </p>

                                        <span className="flex ml-5">
                                            <div className="mr-[20px]">
                                                <label htmlFor="settlement_type_tp"
                                                    className="flex items-center cursor-pointer">
                                                    
                                                    <input
                                                        type="radio"
                                                        name="settlement_type"
                                                        id="settlement_type_tp"
                                                        value="trade_price"
                                                        onChange={() =>
                                                            setInput({ ...input, settlement_type: "trade_price" })
                                                        }
                                                        checked={input?.settlement_type === "trade_price"}
                                                    />
                                                    <span></span>
                                                    <span className="py-2 text-lg inline-block">Trade Price</span>
                                                </label>
                                            </div>

                                            <div className="mr-[20px]">
                                                <label htmlFor="settlement_type_np"
                                                    className="flex items-center cursor-pointer">

                                                    <input
                                                        type="radio"
                                                        name="settlement_type"
                                                        id="settlement_type_np"
                                                        value="net_price"
                                                        onChange={() =>
                                                            setInput({ ...input, settlement_type: "net_price" })
                                                        }
                                                        checked={input?.settlement_type === "net_price"}
                                                    />
                                                    <span></span>
                                                    <span className="py-2 text-lg inline-block">Net Price</span>
                                                </label>
                                            </div>
                                        </span>

                                    </div>

                                    <div className="flex w-full py-2">
                                        <div className="relative py-2 mb-1 w-1/2 mr-2">
                                            <input type="text" name="commission" id="commission"
                                                   value={input.commission} title="" placeholder=" "
                                                   onChange={(e) => commissionAmountHandle(e.target)}
                                                   className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer -z-50"
                                                   required/>

                                            <label htmlFor="commission"
                                                   className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Settlement
                                                Charge *</label>

                                            <ul className="items-center float-right -mt-[44px] w-[120px] text-sm font-medium text-gray-900 bg-white rounded-lg  sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white z-50">
                                                <label htmlFor="commission_type_1"
                                                       className="flex items-center w-full z-10 ">
                                                    <input type="radio" name="commission_type" id="commission_type_1"
                                                           onChange={setCommissionAmount} value="percentage"
                                                           defaultChecked/>
                                                    <span></span>
                                                    <span className="py-2 text-lg inline-block">%</span>
                                                </label>

                                                <label htmlFor="commission_type_2"
                                                       className="flex items-center w-full z-10 ">
                                                    <input type="radio" name="commission_type" id="commission_type_2"
                                                           onChange={setCommissionAmount} value="amount"/>
                                                    <span></span>
                                                    <span
                                                        className="py-2 pt-3 text-sm inline-block">{process.env.REACT_APP_CURRENCY_SYMBOL}</span>
                                                </label>
                                            </ul>
                                        </div>


                                        <div className="relative py-2 mb-1 w-1/2 ml-2">
                                            <input type="text" name="settlement_cycle" id="settlement_cycle"
                                                   value={input.settlement_cycle} onChange={handleInputChange} title=""
                                                   placeholder=" " maxLength={3}
                                                   className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer -z-50"
                                                   required/>

                                            <label htmlFor="settlement_cycle"
                                                   className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Settlement
                                                Cycle (Days) *</label>
                                        </div>
                                    </div>


                                    <div className="flex">
                                        <p className="text-[18px] pr-3 pt-[6px]">
                                            Service Type
                                        </p>

                                        <span className="flex ml-5 pt-2">
                                            <div className="mr-[20px]">
                                                <input type="checkbox" name="voucher" onChange={handleInputChange}
                                                       checked={input.voucher} id="voucher"
                                                       className="mr-2.5 text-primary focus:ring-primary border-dark-white"/>
                                                <label htmlFor="voucher" className="text-secondary mt-1">Voucher</label>
                                            </div>
                                            <div className="mr-[20px]">
                                                <input type="checkbox" name="shop" onChange={handleInputChange}
                                                       checked={input.shop} id="shop"
                                                       className="mr-2.5 text-primary  focus:ring-primary border-dark-white"/>
                                                <label htmlFor='shop' className="text-secondary">Shop</label>
                                            </div>
                                        </span>

                                    </div>

                                    {/* <div className="relative py-2 mb-1 mt-4">
                                        <input type="text" name="position" value={input?.position} id="position" onChange={handleInputChange} maxLength={5} title="" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer -z-50" />

                                        <label htmlFor="position" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Position</label>
                                    </div> */}


                                    <h3 className="text-xl my-4 mt-10">Bank Account Details Info</h3>
                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="bank_account_name" id="bank_account_name"
                                               value={input.bank_account_name} onChange={handleInputChange}
                                               title="Account Name" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer -z-50"/>

                                        <label htmlFor="bank_account_name"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Account
                                            Name (same as company name)</label>
                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="bank_account_number" id="bank_account_number"
                                               value={input.bank_account_number} onChange={handleInputChange}
                                               title="Account Number" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"/>
                                        <label htmlFor="bank_account_number"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Account
                                            Number</label>
                                    </div>

                                    <div className="relative py-2 mb-1">

                                        <select name="bank_id" id="bank_id" onChange={handleInputChange}
                                                value={input.bank_id}
                                                className='w-full rounded border-solid border border-dark-white'>
                                            <option value="">Choose Bank</option>
                                            {bankList.map((data, index) => (
                                                <option key={index} value={data.id}
                                                        className='text-black'>{data.name}</option>
                                            ))}
                                        </select>


                                    </div>

                                    <div className="relative py-2 mb-1">

                                        <select name="bank_branch_id" id="bank_branch_id" onChange={handleInputChange}
                                                value={input.bank_branch_id}
                                                className='w-full rounded border-solid border border-dark-white'>
                                            <option value="">Choose Branch</option>
                                            {branchList.map((data, index) => (
                                                <option key={index} value={data.id}
                                                        className='text-black'>{data.name}</option>
                                            ))}
                                        </select>

                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="bank_routing" id="bank_routing"
                                               value={input.bank_routing} onChange={handleInputChange}
                                               title="Bank Routing Number" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"/>

                                        <label htmlFor="bank_routing"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Routing
                                            Number</label>
                                    </div>

                                    <h3 className="text-xl my-4">MD/Chairman/Director/Owners/Partner's Info</h3>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="partner_name" id="partner_name"
                                               value={input.partner_name} onChange={handleInputChange} title="Full Name"
                                               placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"/>

                                        <label htmlFor="partner_name"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Full
                                            Name</label>
                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="partner_address" id="partner_address"
                                               value={input.partner_address} onChange={handleInputChange}
                                               title="Address" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"/>

                                        <label htmlFor="partner_address"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Address</label>
                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="partner_phone" id="partner_phone"
                                               value={input.partner_phone} onChange={handleInputChange}
                                               title="Partner Phone" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"/>

                                        <label htmlFor="partner_phone"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Cell
                                            Phone</label>
                                    </div>

                                    <div className="relative pb-2 pt-1 mb-1">
                                        <input type="email" name="partner_email" id="partner_email"
                                               value={input.partner_email} onChange={handleInputChange} title="Email"
                                               placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"/>

                                        <label htmlFor="partner_email"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Email </label>
                                    </div>


                                    <h3 className="text-xl my-4">Point of Contact Info</h3>

                                    <div className="relative pb-2 pt-1 mb-1">
                                        <select name="user_id" id="user_id" onChange={handleInputChange}
                                                value={input.user_id}
                                                className='w-full rounded border-solid border border-dark-white'
                                                required>
                                            <option className='hidden' value="">Choose Company POC *</option>
                                            {userList.map((data, index) => (
                                                <option key={index} value={data.id} data-name={data.name}
                                                        data-email={data.email}
                                                        data-phone={data.mobile_no}
                                                        className='text-black'>{data.name} {'(' + data.email + ')'}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="poc_name" id="poc_name"
                                               value={input.poc_name} onChange={handleInputChange} title="Full Name"
                                               placeholder=" "
                                               className="w-full bg-gray-100 rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"/>

                                        <label htmlFor="poc_name"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Full
                                            Name</label>
                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="poc_phone" id="poc_phone" value={input.poc_phone}
                                               onChange={handleInputChange} title="Cell Phone" placeholder=" "
                                               className="w-full bg-gray-100 rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"/>

                                        <label htmlFor="poc_phone"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Cell
                                            Phone</label>
                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="poc_email" id="poc_email" value={input.poc_email}
                                               onChange={handleInputChange} title="Email" placeholder=" "
                                               className="w-full bg-gray-100 rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"/>

                                        <label htmlFor="poc_email"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Email</label>
                                    </div>

                                    <div className="relative py-2 mb-1">
                                        <input type="text" name="poc_designation" id="poc_designation"
                                               value={input.poc_designation} onChange={handleInputChange}
                                               title="Designation" placeholder=" "
                                               className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"/>

                                        <label htmlFor="poc_designation"
                                               className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Designation</label>
                                    </div>


                                    <h3 className="text-xl my-4">Document List</h3>

                                    <div className="flex pb-2 pt-1 mb-1 items-center">
                                        <div
                                            className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md"
                                            style={{border: "1px solid #e0e0e0"}}>
                                            <input type="file" name="trade_license" className="hidden" ref={fileInput2}
                                                   onChange={handleChange2}/>
                                            <label htmlFor="trade_license" className="p-1 text-base font-medium">Trade
                                                License</label>

                                            {file2 ?
                                                <>
                                                    {file2["type"].includes("image/") ?
                                                        <img src={URL.createObjectURL(file2)}
                                                             alt="Preview Trade License"
                                                             className="max-h-10 max-w-10 ml-auto order-3"/> :
                                                        <span className="text-xs pr-3">{file2["name"]}</span>}
                                                    <button type="button"
                                                            className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs"
                                                            onClick={selectFile2}>Change
                                                    </button>
                                                </> :
                                                <>
                                                    <button type="button"
                                                            className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base"
                                                            onClick={selectFile2}>Upload
                                                    </button>
                                                </>}
                                        </div>

                                        <div
                                            className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md ml-auto order-2"
                                            style={{border: "1px solid #e0e0e0"}}>
                                            <input type="file" className="hidden" name="tin" ref={fileInput3}
                                                   onChange={handleChange3}/>
                                            <label htmlFor="tin" className="p-1 text-base font-medium">TIN/BIN</label>
                                            {file3 ?
                                                <>
                                                    {file3["type"].includes("image/") ?
                                                        <img src={URL.createObjectURL(file3)} alt="Preview TIN/BIN"
                                                             className="max-h-10 max-w-10 ml-auto order-3"/> :
                                                        <span className="text-xs pr-3">{file3["name"]}</span>}
                                                    <button type="button"
                                                            className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs"
                                                            onClick={selectFile3}>Change
                                                    </button>
                                                </> :
                                                <>
                                                    <button type="button"
                                                            className="text-white flex ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer justify- text-base"
                                                            onClick={selectFile3}>Upload
                                                    </button>
                                                </>
                                            }

                                        </div>
                                    </div>

                                    <div className="flex pb-2 pt-1 mb-1 items-center">
                                        <div
                                            className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md"
                                            style={{border: "1px solid #e0e0e0"}}>
                                            <input type="file" name="incorporation" className="hidden" ref={fileInput4}
                                                   onChange={handleChange4}/>
                                            <label htmlFor="incorporation"
                                                   className="p-1 text-base font-medium">Incorporation</label>

                                            {file4 ?
                                                <>
                                                    {file4["type"].includes("image/") ?
                                                        <img src={URL.createObjectURL(file4)}
                                                             alt="Preview Incorporation"
                                                             className="max-h-10 max-w-10 ml-auto order-3"/> :
                                                        <span className="text-xs pr-3">{file4["name"]}</span>}
                                                    <button type="button"
                                                            className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs"
                                                            onClick={selectFile4}>Change
                                                    </button>
                                                </> :
                                                <>
                                                    <button type="button"
                                                            className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base"
                                                            onClick={selectFile4}>Upload
                                                    </button>
                                                </>
                                            }
                                        </div>

                                        <div
                                            className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md ml-auto order-2"
                                            style={{border: "1px solid #e0e0e0"}}>
                                            <input type="file" className="hidden" name="owner_nid" ref={fileInput6}
                                                   onChange={handleChange6}/>
                                            <label htmlFor="owner_nid" className="p-1 text-base font-medium">Owner's
                                                NID</label>
                                            {file6 ?
                                                <>
                                                    {file6["type"].includes("image/") ?
                                                        <img src={URL.createObjectURL(file6)} alt="Preview NID"
                                                             className="max-h-10 max-w-10 ml-auto order-3"/> :
                                                        <span className="text-xs pr-3">{file6["name"]}</span>}
                                                    <button type="button"
                                                            className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs"
                                                            onClick={selectFile6}>Change
                                                    </button>
                                                </> :
                                                <>
                                                    <button type="button"
                                                            className="text-white flex ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer justify- text-base"
                                                            onClick={selectFile6}>Upload
                                                    </button>
                                                </>
                                            }

                                        </div>
                                    </div>


                                    <div className="flex pb-2 pt-1 mb-1 items-center">
                                        <div
                                            className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md"
                                            style={{border: "1px solid #e0e0e0"}}>
                                            <input type="file" name="poc_visiting_card" className="hidden"
                                                   ref={fileInput7} onChange={handleChange7}/>
                                            <label htmlFor="poc_visiting_card" className="p-1 text-base font-medium">POC
                                                Visiting Card/EID</label>

                                            {file7 ?
                                                <>
                                                    {file7["type"].includes("image/") ?
                                                        <img src={URL.createObjectURL(file7)}
                                                             alt="Preview Visiting Card/Eid"
                                                             className="max-h-10 max-w-10 ml-auto order-3"/> :
                                                        <span className="text-xs pr-3">{file7["name"]}</span>}
                                                    <button type="button"
                                                            className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs"
                                                            onClick={selectFile7}>Change
                                                    </button>
                                                </> :
                                                <>
                                                    <button type="button"
                                                            className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base"
                                                            onClick={selectFile7}>Upload
                                                    </button>
                                                </>
                                            }
                                        </div>

                                        <div
                                            className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md ml-auto order-2"
                                            style={{border: "1px solid #e0e0e0"}}>
                                            <input type="file" className="hidden" name="registration_form"
                                                   ref={fileInput8} onChange={handleChange8}/>
                                            <label htmlFor="registration_form" className="p-1 text-base font-medium">Registration
                                                Form</label>
                                            {file8 ?
                                                <>
                                                    {file8["type"].includes("image/") ?
                                                        <img src={URL.createObjectURL(file8)}
                                                             alt="Preview Registration Form"
                                                             className="max-h-10 max-w-10 ml-auto order-3"/> :
                                                        <span className="text-xs pr-3">{file8["name"]}</span>}
                                                    <button type="button"
                                                            className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs"
                                                            onClick={selectFile8}>Change
                                                    </button>
                                                </> :
                                                <>
                                                    <button type="button"
                                                            className="text-white flex ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer justify- text-base"
                                                            onClick={selectFile8}>Upload
                                                    </button>
                                                </>
                                            }

                                        </div>
                                    </div>

                                    <div className="flex pb-2 pt-1 mb-1 items-center">
                                        <div
                                            className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md"
                                            style={{border: "1px solid #e0e0e0"}}>
                                            <input type="file" name="other" className="hidden" ref={fileInput9}
                                                   onChange={handleChange9}/>
                                            <label htmlFor="other" className="p-1 text-base font-medium">Others</label>

                                            {file9 ?
                                                <>
                                                    {file9["type"].includes("image/") ?
                                                        <img src={URL.createObjectURL(file9)} alt="Preview Others"
                                                             className="max-h-10 max-w-10 ml-auto order-3"/> :
                                                        <span className="text-xs pr-3">{file9["name"]}</span>}
                                                    <button type="button"
                                                            className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs"
                                                            onClick={selectFile9}>Change
                                                    </button>
                                                </> :
                                                <>
                                                    <button type="button"
                                                            className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base"
                                                            onClick={selectFile9}>Upload
                                                    </button>
                                                </>
                                            }
                                        </div>
                                    </div>


                                    <Button name="Create New Company"></Button>
                                    {/* <button type="submit" className="text-white bg-primary px-10 py-2 mb-3 mt-5 rounded cursor-pointer hover:bg-brand-dark">Submit</button> */}
                                </form>
                            </div>
                        </main>
                    </div>

                    <style>{`
                    * :disabled {
                        background-color: #F5F5F5 !important;
                    }

                    label > input[type='radio'], input[type="radio"] {
                        display: none;
                    }

                    label > input[type="radio"] + *::before {
                        color: #158560 !important;
                        content: " ";
                        display: inline-grid;
                        width: 1.1rem;
                        height: 1.1rem;
                        border-radius: 50%;
                        border-style: solid;
                        border-width: 0.1rem;
                        border-color: #158560;
                        margin-top: 5px;
                    }

                    label > input[type="radio"]:checked + *::before {
                        background: radial-gradient(#158560 0%, #158560 40%, transparent 50%, transparent);;
                        border-color: #158560;
                    }

                    label > input[type="radio"] + * {
                        display: inline-block;
                        padding: 0.5rem;
                    }

                    input[type="checkbox"] {
                        margin-top: -1px;
                        height: 20px;
                        width: 20px;
                        border: 2px solid #d9d9d9;
                    }

                `}</style>

                </div>}
        </div>
    );
};

export default CreateCompany;